import { useEffect, useRef, useState } from "react";

const CAL_LINK = process.env.REACT_APP_CAL_LINK;
const NS = "wwr-session";

const loadCal = () => {
  /* eslint-disable */
  (function (C, A, L) { let p = function (a, ar) { a.q.push(ar); }; let d = C.document; C.Cal = C.Cal || function () { let cal = C.Cal; let ar = arguments; if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement("script")).src = A; cal.loaded = true; } if (ar[0] === L) { const api = function () { p(api, arguments); }; const namespace = ar[1]; api.q = api.q || []; if (typeof namespace === "string") { cal.ns[namespace] = cal.ns[namespace] || api; p(cal.ns[namespace], ar); p(cal, ["initNamespace", namespace]); } else p(cal, ar); return; } p(cal, ar); }; })(window, "https://app.cal.com/embed/embed.js", "init");
  /* eslint-enable */
};

export const CalEmbed = ({ onBooked }) => {
  const ref = useRef(null);
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    if (!CAL_LINK || !ref.current) return;
    ref.current.innerHTML = "";
    loadCal();
    window.Cal("init", NS, { origin: "https://cal.com" });
    const api = window.Cal.ns[NS];
    api("inline", { elementOrSelector: ref.current, calLink: CAL_LINK, config: { layout: "month_view", theme: "dark" } });
    api("ui", { theme: "dark", hideEventTypeDetails: false, layout: "month_view", cssVarsPerTheme: { dark: { "cal-brand": "#2dd4bf" } } });
    const done = (e) => onBooked?.(e?.detail?.data || {});
    api("on", { action: "bookingSuccessfulV2", callback: done });
    const t = setTimeout(() => setSlow(!ref.current?.querySelector("iframe")), 8000);
    return () => { clearTimeout(t); api("off", { action: "bookingSuccessfulV2", callback: done }); };
  }, [onBooked]);

  if (!CAL_LINK) return <p className="text-sm text-neutral-400" data-testid="cal-not-configured">Online booking is opening soon.</p>;
  return (
    <div>
      <div ref={ref} className="w-full min-h-[640px] overflow-auto rounded-2xl" data-testid="cal-embed" aria-label="Choose a session time" role="region" />
      <p className={`text-xs mt-3 text-center ${slow ? "text-amber-200" : "text-neutral-500"}`} data-testid="cal-fallback">
        {slow ? "The calendar is taking a while to load. " : "Calendar not showing? "}
        <a href={`https://cal.com/${CAL_LINK}`} target="_blank" rel="noopener noreferrer" className="underline text-teal-300 hover:text-teal-200" data-testid="cal-open-new-tab">
          Open booking in a new tab
        </a>
      </p>
    </div>
  );
};
